module.exports = __webpack_public_path__ + "static/intertec_product_1-918d39ed3176cfd339df0295d8ce2bec.avif";